import React, {useState} from 'react';
import classes from "./instruction.module.css";
import {useTelegram} from "../../../../hooks/useTelegram";

const DOCS = {
    ru: {
        title: 'Правила и документы',
        cards: [
            {title: 'Членство', text: '260 Telegram Stars разово. Открывает закрытые раунды, ранги льва, колесо и реферальную программу. Это оплата доступа к приложению, а не инвестиция.'},
            {title: 'Лапы', text: 'Внутренняя игровая валюта. Лапы нельзя купить, вывести, передать другому пользователю или обменять на криптовалюту. Начисляются за подписки и рост вашей команды: 10 лап за друга 1 уровня и по 5 лап на 2–5 уровнях.'},
            {title: 'Закрытые раунды', text: 'У каждого участника есть базовый лимит; приглашённые, подписки и лапы его увеличивают. При переподписке объём делится пропорционально. Цена раунда одинакова для всех, при покупке списываются только лапы.'},
            {title: 'Колесо бонусов', text: 'Ничего — 50 %, возврат 50 лап — 20 %, бесплатный спин — 15 %, 100 лап — 14,49 %, 1 000 лап — 0,5 %, 10 000 лап — 0,01 %. Спин нельзя оплатить деньгами.'},
        ],
        docsTitle: 'Документы',
        docs: [
            {id: 'offer', title: 'Пользовательское соглашение', body: 'Публичная оферта оператора Lion Launch. Акцепт — запуск приложения и/или оплата членства. Лапы не являются деньгами, токенами или иным имуществом. Оператор не обещает доход.'},
            {id: 'privacy', title: 'Политика конфиденциальности', body: 'Обрабатываются данные Telegram, активность в приложении и, при заявке на раунд, адрес кошелька. Данные не продаются. Приложение не предназначено для лиц младше 18 лет.'},
            {id: 'rounds', title: 'Условия закрытых раундов', body: 'Лимит = база + приглашённые + подписки + лапы. Снимок показателей — за 7 дней до окна. При превышении объёма заявки распределяются пропорционально. Цена раунда одинакова для всех.'},
        ],
        operator: 'Оператор приложения',
        operatorText: '[ООО «Название»], УНП [номер], [юридический адрес]\nsupport@alderwayne.group',
        site: 'alderwayne.group',
        risk: 'Lion Launch не обещает доход. Проекты на ранних стадиях несут высокий риск, участие в раунде — ваше самостоятельное решение.',
    },
    eng: {
        title: 'Rules and documents',
        cards: [
            {title: 'Membership', text: '260 Telegram Stars once. Unlocks closed rounds, lion ranks, the bonus wheel and the referral program. This is a payment for access, not an investment.'},
            {title: 'Paws', text: 'Internal game points. Paws cannot be bought, withdrawn, transferred or exchanged for crypto. They are granted for subscriptions and team growth: 10 paws for a level-1 friend and 5 paws on levels 2–5.'},
            {title: 'Closed rounds', text: 'Every member has a base limit. Invites, subscriptions and paws increase it. Oversubscription is allocated pro-rata. The round price is the same for everyone; only paws are spent on a purchase.'},
            {title: 'Bonus wheel', text: 'Nothing 50%, return 50 paws 20%, free spin 15%, 100 paws 14.49%, 1,000 paws 0.5%, 10,000 paws 0.01%. A spin cannot be paid with money.'},
        ],
        docsTitle: 'Documents',
        docs: [
            {id: 'offer', title: 'User agreement', body: 'Public offer of the Lion Launch operator. Acceptance is launching the app and/or paying for membership. Paws are not money, tokens or other property. The operator does not promise income.'},
            {id: 'privacy', title: 'Privacy policy', body: 'We process Telegram data, in-app activity and, when you apply for a round, a wallet address. Data is not sold. The app is not intended for people under 18.'},
            {id: 'rounds', title: 'Closed-round terms', body: 'Limit = base + invites + subscriptions + paws. Snapshot is taken 7 days before the window. Oversubscription is allocated pro-rata. The price is the same for everyone.'},
        ],
        operator: 'Application operator',
        operatorText: '[Legal entity], UNP [number], [address]\nsupport@alderwayne.group',
        site: 'alderwayne.group',
        risk: 'Lion Launch does not promise income. Early-stage projects carry high risk. Taking part in a round is your own decision.',
    }
}

const Instruction = ({lang}) => {
    const t = DOCS[lang] || DOCS.ru
    const {openExternal} = useTelegram()
    const [openDoc, setOpenDoc] = useState(null)
    const current = t.docs.find((item) => item.id === openDoc)

    return (
        <div className={classes._}>
            <div className={classes.pageTitle}>{t.title}</div>
            <div className={classes.block}>
                {t.cards.map((card) => (
                    <div className={classes.card} key={card.title}>
                        <div className={classes.cardTitle}>{card.title}</div>
                        <div className={classes.text}>{card.text}</div>
                    </div>
                ))}
                <div className={classes.card}>
                    <div className={classes.cardTitle}>{t.docsTitle}</div>
                    {t.docs.map((doc) => (
                        <button type="button" className={classes.docLink} key={doc.id} onClick={() => setOpenDoc(doc.id)}>
                            <span>{doc.title}</span><span>›</span>
                        </button>
                    ))}
                </div>
                {current && (
                    <div className={classes.card}>
                        <div className={classes.cardTitle}>{current.title}</div>
                        <div className={classes.text}>{current.body}</div>
                    </div>
                )}
                <div className={classes.card}>
                    <div className={classes.cardTitle}>{t.operator}</div>
                    <div className={classes.text}>{t.operatorText}</div>
                    <a
                        className={classes.site}
                        href="https://alderwayne.group"
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => {
                            e.preventDefault()
                            openExternal('https://alderwayne.group')
                        }}
                    >
                        {t.site}
                    </a>
                </div>
                <p className={classes.risk}>{t.risk}</p>
            </div>
        </div>
    );
};

export default Instruction;
